import React from 'react'
import {PublicEmployment} from '@icofcv/common';
import {Where} from '@loopback/repository';

export function createPublicEmploymentWhereFilter(publicEmploymentFilter:any) {
    const searchParam = publicEmploymentFilter.searchPublic ? `%${publicEmploymentFilter.searchPublic}%` : '';
    const searchProvinceParam = publicEmploymentFilter.searchProvince;
    const searchScopeParam = publicEmploymentFilter.searchScope;
    
    const searchParamsOr:Where<PublicEmployment>[] = [];
    if (searchParam && searchParam.trim().length > 0) {
        console.log(`*** searchParamsOr - title: '${searchParam}'`);
        searchParamsOr.push({ title: { like: searchParam, options: 'i' } });
    }

    const searchParamsAnd:Where<PublicEmployment>[] = [];
    if (searchScopeParam && searchScopeParam.trim().length > 0) {
        console.log(`*** searchParamsAnd - scope: '${searchScopeParam}'`);
        searchParamsAnd.push({ scope:  { eq: searchScopeParam } });
    }
    if (searchProvinceParam && searchProvinceParam.trim().length > 0) {
        console.log(`*** searchParamsAnd - provinceType: '${searchProvinceParam}'`);
        searchParamsAnd.push({ provinceType: { eq: searchProvinceParam } });
    }
    

    let where = {};
    if (searchParamsOr.length > 0 || searchParamsAnd.length > 0) {
        if (searchParamsOr.length > 0 && searchParamsAnd.length > 0) {
            where = { 
                and: [
                    { or: searchParamsOr },
                    { searchParamsAnd }
                ]
            };
        } 
        if (searchParamsOr.length > 0 && searchParamsAnd.length == 0) {
            where = { 
                or: searchParamsOr
            };
        }
        if (searchParamsOr.length == 0 && searchParamsAnd.length > 0) {
            where = { 
                and: searchParamsAnd
            };
        }
    }

    return where;
}